export default __webpack_public_path__ + "static/media/r4_bow_favonius_warbow.8418ae60.png";